export default __webpack_public_path__ + "953a0f1731c10a25f62de5bc1115ef48.png";